import type { MagazineAnalyticsSetting_DesignPageQuery, PaymentDepositAccount } from "@/lib/gql/__generated__/graphql";

import type { AutoGeneratorForFormModel } from "@/components/features/_model";

import type { MagazineAnalyticsSettingInputZodSchemaType } from "./validation-schema";

export type ServerModel = MagazineAnalyticsSetting_DesignPageQuery;

const _excludeKeys = ["hotelID"] as const;
export const excludeKeys = _excludeKeys.map((key) => key);
export type ExcludeKeys = (typeof excludeKeys)[number];

export type MagazineAnalyticsSettingFormModel = AutoGeneratorForFormModel<
	MagazineAnalyticsSettingInputZodSchemaType,
	ExcludeKeys,
	PaymentDepositAccount
>;
